module.exports = __webpack_public_path__ + "img/DS.d184e874.png";